import classNames from "classnames"

import { Color } from "../../../../constants/V2/color"
import TextButton from "../../../elements/V2/Buttons/TextButton"
import GatsbyStoryblokImage from "../../../elements/V2/GatsbyStoryblokImage"
import ArrowIcon from "../../../elements/V2/Icons/ArrowIcon"
import Typography from "../../../elements/V2/Typography"
import LayoutItem from "../../Layouts/LayoutItem"

import { getAccentColor, getBackgroundColorClass } from "@utils/V2/color"
import React from "react"

type Props = {
  backgroundColor: Color
  superscriptText: string
  titleText: string
  descriptionText: string
  size?: "large" | "small"
  imageUrl: string
  imageAlt: string
  buttonText?: string
  buttonLink?: string | YocoCom.YocoLink
  imageRounded?: boolean
  mobileGridOrder?: number
  trackingEvent?: string
  trackingEventKey?: string
  trackingEventValue?: string
}

const Benefits = ({
  backgroundColor,
  superscriptText,
  titleText,
  descriptionText,
  size = "large",
  imageUrl,
  imageAlt,
  buttonText,
  buttonLink,
  imageRounded = false,
  mobileGridOrder,
  trackingEvent,
  trackingEventKey,
  trackingEventValue,
  ...props
}: Props) => {
  const accentColor = getAccentColor(backgroundColor)

  return (
    <LayoutItem
      mobileGridOrder={mobileGridOrder}
      as="div"
      animateOnScroll
      className={classNames(
        getBackgroundColorClass(backgroundColor),
        "rounded-lg col-span-full flex flex-col justify-between overflow-hidden border-none sm:col-span-2 md:col-span-3",
        size === "large" ? "lg:col-span-6" : "lg:col-span-4"
      )}
      {...props}
    >
      <div className="flex flex-col items-center gap-20 px-20 py-32 md:gap-24 md:px-24 lg:gap-32 lg:px-32 lg:py-48">
        <div className="flex flex-col items-center gap-8 md:gap-16">
          <Typography
            font="grotesk"
            weight="book"
            size="subscript-lg"
            color={accentColor}
            text={superscriptText}
            className="text-center uppercase"
          />
          <Typography
            font="grotesk"
            weight="medium"
            size="h3"
            color={accentColor}
            text={titleText}
            className="text-center"
            element="h3"
          />
        </div>
        <Typography
          font="grotesk"
          weight="book"
          size="body-lg"
          color={accentColor}
          text={descriptionText}
          className="text-center"
        />
        {buttonText && buttonLink && (
          <TextButton
            style="icon"
            color={accentColor}
            text={buttonText}
            linkUrl={buttonLink}
            icon={<ArrowIcon />}
            trackingEvent={trackingEvent}
            trackingEventKey={trackingEventKey}
            trackingEventValue={trackingEventValue}
          />
        )}
      </div>

      <GatsbyStoryblokImage
        aspectRatio="4:3"
        image={imageUrl}
        alt={imageAlt || "Benefit image"}
        imageObjectFit="contain"
        className={classNames(
          "w-full [&_img]:object-bottom",
          imageRounded && "rounded-t-lg"
        )}
      />
    </LayoutItem>
  )
}

export default Benefits
